import React from 'react'
import styled from '@emotion/styled'

const StyledSectionContainer = styled('div')`
    // background: #abc;
    // overflow-y: auto;
    // overflow-x: hidden;
    // transform: rotate(-90deg) translateY(-80px);
    // transform-origin: right top;
    height: 100vh;
    width: 100vw;
    background-image: url(./img/sedona.jpg);
    background-position: center;
    @media (max-width: 500px) {
        background-position: 35% 20%;
    }
`

const StyledWelcomeCopy = styled('div')`
    width: 50%;
    margin-left: auto;
    background-color: #3e3e3e;
    padding: 2rem;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    color: white;
    @media (max-width: 800px) {
        flex: 1 1 50%;
        width:100%;
    }
`
const StyledTitleBar = styled('div')`
    width: 100vw;
    padding: 2rem;
    background-color: white;
    color: rgb(50, 20, 93);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
`

const Welcome = () => {
    return (
        <React.Fragment>
            <StyledSectionContainer>
                <StyledTitleBar>
                    Christian Lamborghini - Software Engineer
                </StyledTitleBar>
                <StyledWelcomeCopy>
                    <h1>Hello, my name is Christian.</h1>
                    <p>
                        I am a senior full-stack software engineer with an expertise on the frontend. I am a team
                        player that's excited for my next challenge. Each day I
                        bring positivity and pragmatism that helps me breakdown
                        problems into bite sized pieces to allow the team to
                        succeed in delivering quality, tested, clean code.
                    </p>
                </StyledWelcomeCopy>
            </StyledSectionContainer>
        </React.Fragment>
    )
}

export default Welcome



// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.js